import {Component} from '@angular/core';
import {environment} from "../../../environments/environment";
import {UrlConfigService} from "../../@core/services/config/url-config/url-config.service";

@Component({
    selector: 'app-footer-custom',
    templateUrl: './footer-custom.component.html',
    styleUrls: ['./footer-custom.component.scss'],
    standalone: false
})
export class FooterCustomComponent {

  currYear = new Date().getFullYear();
  version = environment.version;

  constructor(
    private urlConfigService: UrlConfigService
  ) {
  }


  navigateToImpressum() {
    this.urlConfigService.getImpressumUrl()
      .subscribe((impressumUrl) => {
        window.open(
          impressumUrl,
          '_blank'
        );
      });


  }

  navigateToDatenschutz() {
    this.urlConfigService.getDatenschutzUrl()
      .subscribe((datenschutzUrl) => {
        window.open(
          datenschutzUrl,
          '_blank'
        );
      });


  }
}
